export const POST_NOTE_ACCOUNT = 'mac/POST_NOTE_ACCOUNT';
